(() => {
  if (customElements.get('signature-premium')) return;

  class SignaturePremium extends HTMLElement {
    connectedCallback() {
      this.onLoad = () => this.initialize();
      this.onSectionLoad = (event) => {
        if (event.target.contains(this)) this.initialize();
      };
      this.onSectionUnload = (event) => {
        if (event.target.contains(this)) this.destroy();
      };
      window.addEventListener('load', this.onLoad);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:section:unload', this.onSectionUnload);
      this.initialize();
    }

    initialize() {
      if (typeof window.Swiper !== 'function') return;
      this.querySelectorAll('[data-premium-slider]').forEach((element) => {
        if (element.swiper && !element.swiper.destroyed) return;
        const muse = element.dataset.premiumSlider === 'muse';
        new window.Swiper(element, {
          slidesPerView: muse ? 'auto' : 1,
          spaceBetween: 0,
          speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450,
          watchOverflow: true,
          grabCursor: true,
          navigation: muse ? false : {
            prevEl: element.querySelector('.signature-premium__prev'),
            nextEl: element.querySelector('.signature-premium__next')
          },
          scrollbar: muse ? {
            el: element.querySelector('.signature-premium__muse-scrollbar'),
            draggable: true,
            hide: false
          } : false,
          a11y: {
            enabled: true,
            prevSlideMessage: muse ? 'Previous Vanessa product' : 'Previous awards photo',
            nextSlideMessage: muse ? 'Next Vanessa product' : 'Next awards photo'
          },
          on: { init() { element.classList.add('is-ready'); } }
        });
      });
    }

    destroy() {
      this.querySelectorAll('[data-premium-slider]').forEach((element) => {
        if (element.swiper && !element.swiper.destroyed) element.swiper.destroy(true, true);
        element.classList.remove('is-ready');
      });
    }

    disconnectedCallback() {
      this.destroy();
      window.removeEventListener('load', this.onLoad);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }
  }

  customElements.define('signature-premium', SignaturePremium);
})();
